import React, {useEffect, useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import {ErrorFlow, Config} from 'olympe';
import {getRequestCockpitLink} from '../../../utils/helpers';

/**
 * @param {EndOfSubmitPRContent.propTypes} props
 * @return {Element}
 * @constructor
 */
export function EndOfSubmitPRContent(props) {
    const [open, setOpen] = useState(true);

    let color;
    let title;
    let text;
    let secondaryText;
    let icon;
    let eventCode;

    const redirectLink = getRequestCockpitLink(Config.getParameter('ENV'));

    // Display the popup each time we receive a new error/success
    useEffect(() => {
        setOpen(true);
    }, [props.inputCtrlFlow, props.errorFlow]);

    if (props.errorFlow) {
        color = 'red';
        icon = 'error';
        if (props.errorDescriptor && typeof props.errorDescriptor === 'object' && 'description' in props.errorDescriptor && 'code' in props.errorDescriptor) {
            // If the error description contains multiple errors
            if (typeof props.errorDescriptor.description === 'string' && props.errorDescriptor.description.includes('#')) {
                const firstPart = props.errorDescriptor.description.substring(0, props.errorDescriptor.description.indexOf('#'));
                const secondPart = props.errorDescriptor.description.substring(props.errorDescriptor.description.indexOf('#'));

                title = firstPart;
                text = secondPart.split('#').slice(1);
            } else {
                // If the error code is between 2010 and 2020, this is an error received from SAP Submit PR API
                if (props.errorDescriptor.code >= 2010 && props.errorDescriptor.code < 2020) {
                    title = `SAP Purchase Request cannot be generated.`;
                } else {
                    title = `There's an issue during the submission process.`;
                }
                text = props.errorDescriptor.description.value || props.errorDescriptor.description;
            }
            secondaryText = `Error code: ${props.errorDescriptor.code} in brick ${props.errorDescriptor.nameOfBrick} (${props.errorDescriptor.tagOfBrick})`;
            eventCode = props.errorDescriptor.eventCode;
        } else {
            title = `There's an issue during the submission process.`;
            text = props.errorFlow.getMessage();
            secondaryText = `Error code: ${props.errorFlow.getCode()}`;
        }
    } else {
        color = '#008000';
        icon = 'check_circle';
        title = `Your request has been successfully sent.`;
        text = (
            <>
                {`Your Purchase Request #${props.sapPRNumber} has been submitted. Please refer back to the `}
                <a href={redirectLink} target={'_blank'} rel="noreferrer">Request Cockpit</a>
                {` for further information and additional actions regarding the request, or close this popup to continue managing your open requests.`}
            </>
        );
    }

    const handleClose = () => {
        setOpen(false);
        if (props.errorFlow) {
            props.setErrorFlow(props.errorFlow);
        } else {
            props.setSapPRNumber(props.sapPRNumber);
            props.forwardEvent();
        }
    };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            scroll={'paper'}
            aria-labelledby="end-of-submit-process-title"
            style={{flexDirection: 'row'}}
        >
            <div style={{display: 'flex'}}>
                <div style={{backgroundColor: color, width: '10%', height: 'auto', display: 'flex', alignItems: 'center', minWidth: '50px', justifyContent: 'center'}}>
                    <i className="material-icons" style={{color: 'white'}}>{icon}</i>
                </div>
                <div style={{width: '90%', overflowWrap: 'anywhere'}}>
                    <DialogTitle id="popup-title">{title}</DialogTitle>
                    <DialogContent>

                        {Array.isArray(text) ? (
                            <ul> {text.map((msg, idx) => {
                                return (
                                    <li key={msg + idx}>
                                        <DialogContentText >
                                            {msg}
                                        </DialogContentText>
                                    </li>
                                );
                            })
                            }
                            </ul>) : (
                            <DialogContentText id="popup-description">{text}</DialogContentText>
                        )}
                        {secondaryText &&
                            <div className={'dialog-secondary-text'}>
                                {secondaryText}
                            </div>
                        }
                        {eventCode &&
                            <div className={'dialog-secondary-text'} style={{marginTop: '0'}}>
                                {`Event code: ${eventCode}`}
                            </div>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button data-cy={'sent_PR_popup_ok_button'} key={'endOfSubmitBtn'} onClick={handleClose}>
                            OK
                        </Button>
                    </DialogActions>
                </div>
            </div>
        </Dialog>
    );
}

EndOfSubmitPRContent.propTypes = {
    inputCtrlFlow: PropTypes.number,
    forwardEvent: PropTypes.func,
    setSapPRNumber: PropTypes.func,
    setErrorFlow: PropTypes.func,
    sapPRNumber: PropTypes.string,
    errorDescriptor: PropTypes.object,
    errorFlow: PropTypes.instanceOf(ErrorFlow),
};
